if (!customElements.get('atelier-collection-description')) {
  customElements.define('atelier-collection-description', class extends HTMLElement {
    connectedCallback() {
      this.disclosure = this.querySelector('details');
      if (!this.disclosure) return;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.syncDisclosure = () => { this.disclosure.open = this.desktopQuery.matches; };
      this.syncDisclosure();
      this.desktopQuery.addEventListener('change', this.syncDisclosure);
    }
    disconnectedCallback() {
      if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.syncDisclosure);
    }
  });
}
